/**
 * Pokedex page strings (PR-4.1, v0.9.0).
 *
 * Keys are scoped under `pokedex.*`. The breed unlock-hint string itself is
 * NOT in here — those come from the API (`unlock_hint_zh` / `_en` columns on
 * the `breeds` table) so parents/admins can edit them without a code release.
 */
const pokedex = {
  zh: {
    'pokedex.title': '宠物图鉴',
    'pokedex.subtitle': '收集你陪伴过的小伙伴',
    'pokedex.tab.shop': '商店',
    'pokedex.tab.pokedex': '图鉴',
    'pokedex.stats.collected': '已收集 {n} / {total}',
    'pokedex.card.firstOwnedAt': '首次获得 {date}',
    'pokedex.card.totalInteractions': '互动 {n} 次',
    'pokedex.card.locked': '???',
    'pokedex.empty.title': '图鉴还是空的',
    'pokedex.empty.hint': '去商店领养你的第一只小伙伴吧～',
    'pokedex.error.load': '图鉴加载失败',
  } as Record<string, string>,
  en: {
    'pokedex.title': 'Pet Pokedex',
    'pokedex.subtitle': 'Every friend you have kept company',
    'pokedex.tab.shop': 'Shop',
    'pokedex.tab.pokedex': 'Pokedex',
    'pokedex.stats.collected': 'Collected {n} / {total}',
    'pokedex.card.firstOwnedAt': 'First met {date}',
    'pokedex.card.totalInteractions': '{n} chats together',
    'pokedex.card.locked': '???',
    'pokedex.empty.title': 'Pokedex is empty',
    'pokedex.empty.hint': 'Adopt your first companion at the shop!',
    'pokedex.error.load': "Couldn't load the pokedex",
  } as Record<string, string>,
};

export default pokedex;
